import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useCardsAnalytics from './useCardsAnalytics';

interface UseCardsAnalyticsRoutingGuardProps {
  redirectPath: string;
}

/**
 * Hook for restricting access for Cards Analytics routes
 */
const useCardsAnalyticsRoutingGuard = ({
  redirectPath,
}: UseCardsAnalyticsRoutingGuardProps) => {
  const history = useHistory();
  const cardsAnalyticsFeatureFlag = useCardsAnalytics();

  useEffect(() => {
    // Keep the guard mounted for route compatibility while Cards Analytics is always on.
    // Avoid redirecting while feature flags are still loading (e.g. during HMR)
    if (cardsAnalyticsFeatureFlag === undefined) {
      return;
    }

    if (cardsAnalyticsFeatureFlag === true) {
      return;
    }

    history.push(redirectPath);
  }, [cardsAnalyticsFeatureFlag, history, redirectPath]);
};

export default useCardsAnalyticsRoutingGuard;
